export default "/assets/images/app-showcase-04.jpg?87a68e1ddc542bdc7418348f6bd1640f";